import $ from 'jquery'

export function initialise() {
  const $header = $('header.header')
  const $menu = $('nav.menu-nav')

  $menu.find('> ul > li').each((_i, li) => {
    const liFocus = () => {
      if ($header.hasClass('header-inverted')) $header.addClass('header-active')
    }
    const liBlur = () => {
      if ($header.hasClass('header-inverted')) $header.removeClass('header-active')
    }
    $(li).on('mouseover', liFocus)
    $(li).on('focus', liFocus)
    $(li).on('mouseout', liBlur)
    $(li).on('blur', liBlur)
  })
}
